var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.episode)?_c('router-link',{attrs:{"to":_vm.routerLink},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.item.episode))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }